import { render, staticRenderFns } from "./ArrowsIcon.vue?vue&type=template&id=38397470&"
import script from "./ArrowsIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports